import {
    put, takeLatest, call
} from 'redux-saga/effects';
import {authenticatedAxios} from '../client';
import {
    GET_ZELLE_USER, getZelleUser,
    LOOKUP_ZELLE_USER, lookupZelleUser,
    SUBMIT_ZELLE_REQUEST, submitZelleRequest
} from "../actions/zelle";

function* handleGetZelleUser({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        // const response = yield call(authenticatedAxios.get, `${window.api_url}/dave/get-zelle-user`);
        const response = yield call(authenticatedAxios.get, `${window.api_url}/site-secure/zelle/account-info`);

        yield put(getZelleUser({
            getZelleUserSuccess: true,
            zelleUser: response.data.data,
        }, {'sent': true}));

    } catch (error) {
        yield put(getZelleUser(error, {}, true));
    }
}
export function* watchGetZelleUser() {
    yield takeLatest(GET_ZELLE_USER, handleGetZelleUser);
}



function* handleLookupZelleUser({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const params = {
            firstname: payload.firstName,
            lastname: payload.lastName,
            token_id: payload.contactType === 'emailAddress' ? payload.emailAddress : payload.phoneNumber,
            token_type: payload.contactType === 'emailAddress' ? 'email' : 'mobile'
        }

        // const response = yield call(authenticatedAxios.post, `${window.api_url}/dave/lookup-zelle-user`);
        const response = yield call(authenticatedAxios.post, `${window.api_url}/site-secure/zelle/account-lookup`, params);

        yield put(lookupZelleUser({
            lookupZelleUserSuccess: true,
            zelleUser: response.data.data,
        }, {'sent': true}));

    } catch (error) {
        yield put(lookupZelleUser(error, {}, true));
    }
}
export function* watchLookupZelleUser() {
    yield takeLatest(LOOKUP_ZELLE_USER, handleLookupZelleUser);
}



function* handleSubmitZelleRequest({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const {link, ...params} = payload;
        const response = yield call(authenticatedAxios.post, link, params);

        console.log('response',response);

        yield put(submitZelleRequest({
            submitZelleRequestSuccess: true,
            submitZelleRequestStatus: response.status,
            submitZelleRequestTransactionAmount: response.data.replacement_amount
        }, {'sent': true}));

    } catch (error) {
        yield put(submitZelleRequest(error, {}, true));
    }
}
export function* watchSubmitZelleRequest() {
    yield takeLatest(SUBMIT_ZELLE_REQUEST, handleSubmitZelleRequest);
}